import React, { useState } from "react";
import { Popover, Select, Input, Button } from "antd";
import { ToolFilled } from "@ant-design/icons";
const { Option } = Select;

export default function FilterPopover({
  columnKey,
  currentFilter = {},
  onFilterChange,
}) {
  const [operator, setOperator] = useState(currentFilter.operator || ">");
  const [value1, setValue1] = useState(currentFilter.value1 || "");
  const [value2, setValue2] = useState(currentFilter.value2 || "");

  const operatorOptions = ["=", "!=", "<", "<=", ">", ">=", "between"];

  const handleApply = () => {
    onFilterChange(columnKey, { operator, value1, value2 });
  };

  const content = (
    <div style={{ padding: 8, width: 220 }}>
      <Select
        value={operator}
        onChange={setOperator}
        style={{ width: "100%", marginBottom: 8 }}
      >
        {operatorOptions.map((op) => (
          <Option key={op} value={op}>
            {op}
          </Option>
        ))}
      </Select>
      <Input
        placeholder="Value"
        value={value1}
        onChange={(e) => setValue1(e.target.value)}
        style={{ marginBottom: 8 }}
      />
      {operator === "between" && (
        <Input
          placeholder="and"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          style={{ marginBottom: 8 }}
        />
      )}
      <div style={{ textAlign: "right" }}>
        <Button size="small" onClick={handleApply}>
          Apply
        </Button>
      </div>
    </div>
  );

  return (
    <Popover content={content} title="Filter" trigger="click">
      <div style={{ paddingRight: "5px", cursor: "pointer" }}>ƒx</div>
    </Popover>
  );
}
